import request from 'utils/request'

/**
 * Actions
 */
const FETCH_INSIGHTS_URL = 'FETCH_INSIGHTS_URL'

/**
 * Action Creators
 */
const _fetchInsightsUrlState = state => dispatch => {
  dispatch({
    type: FETCH_INSIGHTS_URL,
    payload: state,
  })
}

const openTab = url => window.open(url)

export const fetchInsightsRedirectUrl = ({ dashboardId = '', studyID }) => dispatch => {
  dispatch(_fetchInsightsUrlState(true))
  return dispatch(
    request({
      url: `/control/studies/${studyID}/insights/redirect${dashboardId ? `/dashboards/${dashboardId}` : ''}`,
      errorMessage: 'error fetching insights url',
      success: textResponse => openTab(textResponse),
      hasLoader: true,
      loadingKey: 'insights',
      resType: 'text',
    }),
  ).then(() => dispatch(_fetchInsightsUrlState(false)))
}

/**
 * Reducers
 */
const sideBar = (state = {}, action) => {
  switch (action.type) {
    case FETCH_INSIGHTS_URL:
      return { fetchingInsightsUrl: action.payload }
    default:
      return state
  }
}

/**
 * Function
 */
export default sideBar
